module.exports = __webpack_public_path__ + "img/mixerstu1.71a8e20b.jpeg";